import React, { Suspense } from 'react';
import { useComponentTranslations } from '@core/js/hooks/component';
import { Balance } from '@core/js/components/main/Balance';

import style from './AccountPanelTotal.scss';

export const AccountPanelTotal: React.FC = () => {
    const translate = useComponentTranslations();

    return (
        <div className={style.accountPanelTotal}>
            <span className={style.totalName}>
                {translate('header.account-panel-total.name.title')}
            </span>
            <span className={style.totalAmount}>
                <Suspense fallback="">
                    <Balance type="casino_gaming_balance" />
                </Suspense>
            </span>
        </div>
    );
};
